import React from 'react';
import { TimePicker as AntdTimePicker } from 'antd';

const TimePicker = ({
  label = '',
  placeholder = '',
  required = false,
  value = '',
  onChange = () => {},
  disabled,
  use12Hours = true,
  format = 'hh:mm a',
  minuteStep = 15,
}) => {
  return (
    <AntdTimePicker
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      use12Hours={use12Hours}
      value={value}
      onChange={onChange}
      style={{ height: '100%' }}
      format={format}
      minuteStep={minuteStep}
    />
  );
};

export default TimePicker;
